import { Native } from '../../../utils/native/native';
import { CoreAuthProviderProps } from '../types';
import { NativeLegacySessionRefreshProvider } from './legacy/CoreAuthNative';

/**
 * Renders the native authentication provider for the application.
 *
 * Switches between the legacy native authentication provider and the new native authentication provider based on the native webview presence.
 */
const CoreAuthNativeProvider = (props: CoreAuthProviderProps) => {
  if (!Native.WebView) {
    return null;
  }
  return <NativeLegacySessionRefreshProvider {...props} />;
};

export { CoreAuthNativeProvider };
